import $ from 'jquery';

window.openModalContactRequest = id => {
  const modal = $('#c'+id).find('.modal');

  $(modal).addClass('is-open');
  $('body').addClass('is-offscroll');

  $(modal).find('.modal__close').on('click', {modal: modal}, window.closeModalContactRequest);
  $(modal).on('click', {modal: modal}, function(e) {
    if (e.data.modal.get(0) === e.target) {
      window.closeModalContactRequest(e);
    }
  });

  var closeButton = $(modal).find('.close-button .btn');
  closeButton.on('click', {modal: modal}, function(e) {
    var loadingIcon = $(modal).find('.loading-icon');
    var checkIcon = $(modal).find('.check-icon');

    loadingIcon.addClass('active');
    loadingIcon.css('margin-left', (closeButton.outerWidth() + closeButton.find('span').width()) / 2);

    setTimeout(function() {
      loadingIcon.removeClass('active');

      checkIcon.addClass('active');
      checkIcon.css('margin-left', (closeButton.outerWidth() + closeButton.find('span').width()) / 2);
    }, 500);

    setTimeout(function() {
      window.closeModalContactRequest(e);
      checkIcon.removeClass('active');
    }, 1000);
  });
};

window.closeModalContactRequest = e => {
  const modal = e.data.modal;

  $(modal).removeClass('is-open');
  $('body').removeClass('is-offscroll');

  $(modal).find('.wrapper-message').hide();
  $(modal).find('.wrapper-form').show();

  const submitButton = $(modal).find('input[type="submit"]');
  submitButton.removeClass('btn_success');
  submitButton.prop('disabled', false);
  submitButton.css('cursor', 'pointer');

  $(modal).off('click');
  $(modal).find('.modal__close').off('click');
  $(modal).find('.close-button .btn').off('click');
};
